export const SECTION_META = 'meta';
export const SECTION_SETTINGS = 'settings';
export const SECTION_VIDEO_OVERLAY = 'markup:twitch-extension:overlay--interactive';

export const SECTIONS = [
	SECTION_META,
	SECTION_SETTINGS,
	SECTION_VIDEO_OVERLAY,
];
